import React, { useEffect, useState } from "react";
import CustomLoader from "../components/CustomLoader";
import { toast } from "react-toastify";
import { BeatLoader } from "react-spinners";
import { getApi, putFormDataApi } from "../config/configAxios";
import JoditEditor from "jodit-react";
import { config } from "../utils/JoditConfig";
import AdminLayout from "../layouts/adminLayout/AdminLayout";

const WebsiteSetting = () => {
  const [data, setData] = useState({});
  const [oldFile, setOldFile] = useState({});
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getApi("website-setting");
      setData(res.data);
      setOldFile(res.data);
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setData((prevData) => ({ ...prevData, file: file }));
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    setData((prevData) => ({ ...prevData, banner: file }));
  };
  const handleAdminLogoChange = (e) => {
    const file = e.target.files[0];
    setData((prevData) => ({ ...prevData, admin_logo: file }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("id", oldFile.id);
    formData.append("content_en", data.content_en);
    formData.append("content_bn", data.content_bn);
    formData.append("message_en", data.message_en);
    formData.append("message_bn", data.message_bn);
    formData.append("google_map", data.google_map);
    formData.append("title_en", data.title_en);
    formData.append("title_bn", data.title_bn);
    formData.append("file", data.file);
    formData.append("banner", data.banner);
    formData.append("admin_logo", data.admin_logo);
    formData.append("fb", data.fb);
    formData.append("fb_page", data.fb_page);
    formData.append("yt", data.yt);
    formData.append("twi", data.twi);
    formData.append("mobile", data.mobile);
    formData.append("email", data.email);
    formData.append("address", data.address);
    formData.append("privacy_policy_en", data.privacy_policy_en);
    formData.append("privacy_policy_bn", data.privacy_policy_bn);
    try {
      await putFormDataApi("website-setting", formData);

      fetchData();
      toast.success("Data updated successfully!");
    } catch (err) {
      toast.error(
        err?.response?.data?.error ||
          err?.response?.data?.message ||
          "update failed",
      );
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout title={"Website setting"}>
      {loading ? (
        <CustomLoader />
      ) : (
        <div className="p-6 bg-white !rounded">
          <form className="" onSubmit={handleUpdate}>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
              <div>
                <label htmlFor="title_en" className="font-semibold text-sm">
                  Title EN
                </label>
                <input
                  type="text"
                  id="title_en"
                  name="title_en"
                  value={data?.title_en}
                  onChange={handleInputChange}
                  placeholder="title_en"
                  className="form-control"
                  required
                />
              </div>
              <div>
                <label htmlFor="title_bn" className="font-semibold text-sm">
                  Title BN
                </label>
                <input
                  type="text"
                  id="title_bn"
                  name="title_bn"
                  value={data?.title_bn}
                  onChange={handleInputChange}
                  placeholder="title_bn"
                  className="form-control"
                  required
                />
              </div>
              <div>
                <label htmlFor="file" className="font-semibold text-sm">
                  Logo
                </label>
                <input
                  type="file"
                  id="file"
                  name="file"
                  onChange={handleFileChange}
                  placeholder="Charger votre fichier"
                  className="form-control"
                />
              </div>
              <div className="flex gap-2">
                <div>
                  <label htmlFor="file" className="font-semibold text-sm">
                    Logo
                  </label>
                  <img
                    className="h-20 border border-dashed rounded-md p-3"
                    src={`${process.env.REACT_APP_API_FILE_URL}${oldFile?.file}`}
                    alt=""
                  />
                </div>
                <div>
                  {data?.file && typeof data?.file !== "string" && (
                    <>
                      <label htmlFor="file" className="font-semibold text-sm">
                        New image
                      </label>
                      <img
                        className="h-20 border border-dashed rounded-md p-3"
                        src={URL.createObjectURL(data?.file)}
                        alt="Preview"
                      />
                    </>
                  )}
                </div>
              </div>
              <div>
                <label htmlFor="admin_logo" className="font-semibold text-sm">
                  Admin Logo
                </label>
                <input
                  type="file"
                  id="admin_logo"
                  name="file"
                  onChange={handleAdminLogoChange}
                  placeholder="Charger votre fichier"
                  className="form-control"
                />
              </div>
              <div className="flex gap-2">
                <div>
                  <label htmlFor="file" className="font-semibold text-sm">
                    Admin Logo
                  </label>
                  <img
                    className="h-20 border border-dashed rounded-md p-3"
                    src={`${process.env.REACT_APP_API_FILE_URL}${oldFile?.admin_logo}`}
                    alt=""
                  />
                </div>
                <div>
                  {data?.admin_logo && typeof data?.admin_logo !== "string" && (
                    <>
                      <label htmlFor="admin_logo" className="font-semibold text-sm">
                        New Admin Logo
                      </label>
                      <img
                        className="h-20 border border-dashed rounded-md p-3"
                        src={URL.createObjectURL(data?.admin_logo)}
                        alt="Preview"
                      />
                    </>
                  )}
                </div>
              </div>
              <div>
                <label htmlFor="file" className="font-semibold text-sm">
                  Banner
                </label>
                <input
                  type="file"
                  id="banner"
                  name="banner"
                  onChange={handleBannerChange}
                  className="form-control"
                />
              </div>
              <div className="flex gap-2">
                <div>
                  <label htmlFor="file" className="font-semibold text-sm">
                    Banner
                  </label>
                  <img
                    className="h-20 border border-dashed rounded-md p-3"
                    src={`${process.env.REACT_APP_API_FILE_URL}${oldFile?.banner}`}
                    alt=""
                  />
                </div>
                <div>
                  {data?.banner && typeof data?.banner !== "string" && (
                    <>
                      <label htmlFor="banner" className="font-semibold text-sm">
                        New Banner
                      </label>
                      <img
                        className="h-20 border border-dashed rounded-md p-3"
                        src={URL.createObjectURL(data?.banner)}
                        alt="Preview"
                      />
                    </>
                  )}
                </div>
              </div>

              <div className="md:col-span-1">
                <label htmlFor="fb_page" className="font-semibold text-sm">
                  Footer facebook page Link
                </label>
                <input
                  type="text"
                  id="fb_page"
                  name="fb_page"
                  onChange={handleInputChange}
                  value={data?.fb_page}
                  placeholder="facebook page link"
                  className="form-control"
                />
              </div>

              <div className="md:col-span-1">
                <label htmlFor="fb" className="font-semibold text-sm">
                  Facebook
                </label>
                <input
                  type="text"
                  id="fb"
                  name="fb"
                  onChange={handleInputChange}
                  value={data?.fb}
                  placeholder="facebook link"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="yt" className="font-semibold text-sm">
                  Youtube
                </label>
                <input
                  type="text"
                  id="yt"
                  name="yt"
                  onChange={handleInputChange}
                  value={data?.yt}
                  placeholder="Youtube link"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="twi" className="font-semibold text-sm">
                  Twitter
                </label>
                <input
                  type="text"
                  id="twi"
                  name="twi"
                  onChange={handleInputChange}
                  value={data?.twi}
                  placeholder="Twitter link"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="mobile" className="font-semibold text-sm">
                  Mobile
                </label>
                <input
                  type="text"
                  id="mobile"
                  name="mobile"
                  onChange={handleInputChange}
                  value={data?.mobile}
                  placeholder="Mobile number"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="email" className="font-semibold text-sm">
                  Email
                </label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  onChange={handleInputChange}
                  value={data?.email}
                  placeholder="email"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="google_map" className="font-semibold text-sm">
                  Google Map
                </label>
                <input
                  type="text"
                  id="google_map"
                  name="google_map"
                  onChange={handleInputChange}
                  value={data?.google_map}
                  placeholder="google map"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="address" className="font-semibold text-sm">
                  Address
                </label>
                <input
                  type="text"
                  id="address"
                  name="address"
                  onChange={handleInputChange}
                  value={data?.address}
                  placeholder="address"
                  className="form-control"
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="twi" className="font-semibold text-sm">
                  Twitter
                </label>
                <input
                  type="text"
                  id="twi"
                  name="twi"
                  onChange={handleInputChange}
                  value={data?.twi}
                  placeholder="facebook link"
                  className="form-control"
                />
              </div>

              <div className="md:col-span-1"></div>
              <div className="md:col-span-1">
                <label htmlFor="content_en" className="font-semibold text-sm">
                  About EN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.content_en}
                  onBlur={(newContent) =>
                    setData((prevData) => ({
                      ...prevData,
                      content_en: newContent,
                    }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="content_bn" className="font-semibold text-sm">
                  About BN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.content_bn}
                  onBlur={(newContent) =>
                    setData((prevData) => ({
                      ...prevData,
                      content_bn: newContent,
                    }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="message_en" className="font-semibold text-sm">
                  Message EN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.message_en}
                  onBlur={(newmessage) =>
                    setData((prevData) => ({
                      ...prevData,
                      message_en: newmessage,
                    }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label htmlFor="message_bn" className="font-semibold text-sm">
                  Message BN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.message_bn}
                  onBlur={(newmessage) =>
                    setData((prevData) => ({
                      ...prevData,
                      message_bn: newmessage,
                    }))
                  }
                />
              </div>

              <div className="md:col-span-1">
                <label
                  htmlFor="privacy_policy_en"
                  className="font-semibold text-sm"
                >
                  Privacy Policy EN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.privacy_policy_en}
                  onBlur={(newContent) =>
                    setData((prevData) => ({
                      ...prevData,
                      privacy_policy_en: newContent,
                    }))
                  }
                />
              </div>
              <div className="md:col-span-1">
                <label
                  htmlFor="privacy_policy_bn"
                  className="font-semibold text-sm"
                >
                  Privacy Policy BN
                </label>
                <JoditEditor
                  config={config}
                  tabIndex={1}
                  value={data?.privacy_policy_bn}
                  onBlur={(newContent) =>
                    setData((prevData) => ({
                      ...prevData,
                      privacy_policy_bn: newContent,
                    }))
                  }
                />
              </div>

              <div className="md:col-span-2">
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="btn-green w-full"
                  data-ripple-light="true"
                >
                  {isSubmitting ? <BeatLoader color="#fff" /> : "Update"}
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </AdminLayout>
  );
};

export default WebsiteSetting;
